<template>
    <div class="ai-document">
        <header class="ai-document__header">
            <span class="ai-document__title" v-text="!isEmpty() ? 'Attachment Summary:' : 'Attachment'"/>
            <a
                href="#"
                class="ai-document__filename"
                @click.prevent.stop="handleDownload"
                :style="{opacity: downloading ? .5 : 1 }"
                v-html="resource.filename"
            />
        </header>
        <dl :class="{'ai-document__list' : true, 'is-empty' : isEmpty() }">
            <div v-if="resource.overview_summary">
                <dt>Summary</dt>
                <dd v-html="resource.overview_summary"/>
            </div>
            <div v-if="resource.overview_key_people">
                <dt>Key People</dt>
                <dd>
                    <p
                        v-for="people in resource.overview_key_people"
                        v-html="people"
                    />
                </dd>
            </div>
            <div class="half" v-if="resource.overview_primary_tag">
                <dt>Primary Tag</dt>
                <dd v-html="resource.overview_primary_tag"/>
            </div>
            <div class="half" v-if="resource.overview_primary_entity">
                <dt>Primary Entity</dt>
                <dd v-html="resource.overview_primary_entity"/>
            </div>
            <div v-if="resource.overview_secondary_corporate_entities">
                <dt>Secondary Entities</dt>
                <dd>
                    <p
                        v-for="entity in resource.overview_secondary_corporate_entities"
                        v-html="entity"
                    />
                </dd>
            </div>
            <div v-if="resource.overview_secondary_tags">
                <dt>Secondary Tags</dt>
                <dd v-html="resource.overview_secondary_tags.join(', ')"/>
            </div>
        </dl>
    </div>
</template>
<script>
import API from '@api';

export default {
    name: 'AIOverview',
    props: {
        resource: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        downloading: false,
    }),
    methods: {
        async handleDownload() {
            if(this.downloading) {
                return false;
            }

            try {
                this.downloading = true;
                await API.downloadAttachment(this.resource.uuid, this.resource.filename);
            } catch (e) {
                console.warn(e);
            } finally {
                this.downloading = false;
            }
        },
        isEmpty() {
            return !this.resource.overview_summary
                && !this.resource.overview_key_people
                && !this.resource.overview_primary_entity
                && !this.resource.overview_primary_tag
                && !this.resource.overview_secondary_corporate_entities
                && !this.resource.overview_secondary_tags;
        },
    },
}
</script>
<style lang="scss">
.ai-docs {
    list-style: none;
    padding: 0;
    row-gap: 1rem;
}
</style>
<style lang="scss" scoped>
@import "~@/theme/_variables.scss";

.ai-document {
    display: flex;
    flex-direction: column;
    border: 0.1rem solid $border;
    border-radius: 0.4rem;
    background-color: white;
    padding: 1.5rem;
    row-gap: 1rem;

    .ai-document__header {
        display: flex;
        align-items: center;

        .ai-document__title {
            font-size: 1.4rem;
            line-height: 1.4rem;
            font-weight: 500;
            color: #000000;
        }

        .ai-document__filename {
            color: $accent;
            font-weight: bold;
            font-size: 1.2rem;
            line-height: 1.2rem;
            margin-left: auto;
            margin-right: 0;
            display: flex;
            align-items: center;

            mark {
                line-height: 1.6rem;
            }

            &:before {
                content: "";
                display: block;
                height: 1.8rem;
                width: 1.8rem;
                position: relative;
                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 24 24"><path fill="%2325C8C1" d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11l-5 5Zm-6 4q-.825 0-1.413-.588T4 18v-3h2v3h12v-3h2v3q0 .825-.588 1.413T18 20H6Z"/></svg>');
                background-size: 1.8rem;
                margin-right: .4rem;
            }
        }

        @media screen and (max-width: 767px) {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            row-gap: .5rem;

            .ai-document__filename {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }

    .ai-document__list {
        display: flex;
        flex-wrap: wrap;
        row-gap: 1rem;


        &.is-empty {
            display: none !important;
        }

        > div {
            display: flex;
            flex-direction: column;
            row-gap: .4rem;
            font-size: 1.2rem;
            flex: 0 0 100%;

            &.half {
                flex: 0 0 50%;

                @media screen and (max-width: 560px) {
                    flex: 0 0 100%;
                }
            }

            > dt {
                color: #000000;
                font-weight: 500;
            }

            > dd {
                row-gap: .2rem;
                margin-left: 0;

                p {
                    margin: 0;
                }
            }
        }
    }
}
</style>
